import React, { Component } from "react";
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { Col, Row, Button, Label, FormGroup } from "reactstrap";
import { Checkbox, CheckboxGroup, Form, Field } from "@availity/form";
import '@availity/yup';
import * as yup from 'yup';
import { Redirect } from 'react-router-dom';
import moment from 'moment';
import { DateField } from '@availity/date';
import awardeestore from '../stores/awardeestore';
import CustomProgressBar from "../../Common/components/CustomProgressBar";
import AddFile from "../../Common/components/AddFile";

@observer
export default class DocumentationVoucher extends Component {

  constructor(props) {
    super(props);
    this.state = {

      redirectToVoucherProviderInfo: false,
      redirectToVoucheReviewSubmit: false,
    }

    if (awardeestore.getAwardeeUploadDocPageStatus('#documentsVoucher') !== 'stepwizard-step active') {
      awardeestore.setUploadAwardeeHousingPageStatus('#documentsVoucher', 'active');
    }

    if (window.performance) {
      if (performance.navigation.type == 1) {
        awardeestore.resetUploadAwardeeHousingPageStatus();
        window.location.href = '#';
      }
    }
  }

  setDocumentation = value => {
    awardeestore.setDocumentUpload(value);
  }
  setLandlordDoc = value => {
    awardeestore.setLandlordDocUpload(value)
  }

  setDocumentName = event => {
    const { value } = event.target;
    awardeestore.setSelectDocumentName(value);
  }
  setTextDocumentName = event => {
    const { value } = event.target;
    awardeestore.setSelectTextDocName(value);
  }

  componentDidMount() {
    window.onpopstate = () => {
      this.props.history.go(1);
    }
  }

  submit = () => {
    awardeestore.completedSteps.documentsVoucher = true;
    this.setState({ redirectToVoucheReviewSubmit: true });

  }

  goBack = () => {
    this.setState({ redirectToVoucherProviderInfo: true });

  }

  resetDocumentObj = (index) => {
    awardeestore.resetDocumentObj(index);
  }


  render() {
    const {
      redirectToVoucherProviderInfo,
      redirectToVoucheReviewSubmit,
    } = this.state;

    const { userAgent } = navigator;
    const { documentUploadDetails } = awardeestore;


    if (redirectToVoucherProviderInfo) {
      return <Redirect to="/providerAndAwardee" />
    }

    if (redirectToVoucheReviewSubmit) {
      return <Redirect to="/uploadReviewAndSubmit" />
    }

    const {
      documentupload,
      Landlorddoc,
      selectdocumentName,
      selectTextdocumentName,
      uploadAwardeeHousingPages
    } = awardeestore;

    return (
      <div className='border-form'>

        <CustomProgressBar pages={uploadAwardeeHousingPages} />

        <Form
          enableReinitialize
          initialValues={{
            docCheck: documentupload.map(x => x),
            checkbox: Landlorddoc.map(x => x),
            provider_conflict_of_interest_form_fileId_value: documentUploadDetails[0]?.percetComp === 100 ? documentUploadDetails[0]?.fileName : '',
            intent_to_rent_form_fileId_value: documentUploadDetails[1]?.percetComp === 100 ? documentUploadDetails[1]?.fileName : '',
            income_verification_worksheet_fileId_value: documentUploadDetails[2]?.percetComp === 100 ? documentUploadDetails[2]?.fileName : '',
            "verification_of_short-term_subsidy_fileId_value": documentUploadDetails[3]?.percetComp === 100 ? documentUploadDetails[3]?.fileName : '',
            rent_allowance_request_form_fileId_value: documentUploadDetails[4]?.percetComp === 100 ? documentUploadDetails[4]?.fileName : '',
            housing_health_and_safety_inspection_form_fileId_value: documentUploadDetails[5]?.percetComp === 100 ? documentUploadDetails[5]?.fileName : '',
            "lead-based_point_disclosure_fileId_value": documentUploadDetails[6]?.percetComp === 100 ? documentUploadDetails[6]?.fileName : '',
            change_request_form_fileId_value: documentUploadDetails[7]?.percetComp === 100 ? documentUploadDetails[7]?.fileName : '',
            habitability_complaint_process_fileId_value: documentUploadDetails[8]?.percetComp === 100 ? documentUploadDetails[8]?.fileName : '',
            voucher_other_fileId_value: documentUploadDetails[9]?.percetComp === 100 ? documentUploadDetails[9]?.fileName : '',
            voucher_other_fileId_other_value: documentUploadDetails[9]?.customDocumentName ? documentUploadDetails[9]?.customDocumentName : '',
            property_owner_agent_verification_form_fileId_value: documentUploadDetails[10]?.percetComp === 100 ? documentUploadDetails[10]?.fileName : '',
            draft_rental_assistance_payment_agreement_fileId_value: documentUploadDetails[11]?.percetComp === 100 ? documentUploadDetails[11]?.fileName : '',
            copy_of_blank_lease_fileId_value: documentUploadDetails[12]?.percetComp === 100 ? documentUploadDetails[12]?.fileName : '',
            copy_of_executed_lease_fileId_value: documentUploadDetails[13]?.percetComp === 100 ? documentUploadDetails[13]?.fileName : '',
            "move-in_walk_through_fileId_value": documentUploadDetails[14]?.percetComp === 100 ? documentUploadDetails[14]?.fileName : '',
            landlord_other_fileId_value: documentUploadDetails[15]?.percetComp === 100 ? documentUploadDetails[15]?.fileName : '',
            landlord_other_fileId_other_value: documentUploadDetails[15]?.customDocumentName ? documentUploadDetails[15]?.customDocumentName : '',
          }}
          validationSchema={yup.object().shape({
            ...(documentupload.includes("opt1") ? { provider_conflict_of_interest_form_fileId_value: yup.string().required(documentUploadDetails[0]?.percetComp === -1 ? "File upload failed. Please try again." : "File is required!") } : {}),
            ...(documentupload.includes("opt2") ? { intent_to_rent_form_fileId_value: yup.string().required(documentUploadDetails[1]?.percetComp === -1 ? "File upload failed. Please try again." : "File is required!") } : {}),
            ...(documentupload.includes("opt3") ? { income_verification_worksheet_fileId_value: yup.string().required(documentUploadDetails[2]?.percetComp === -1 ? "File upload failed. Please try again." : "File is required!") } : {}),
            ...(documentupload.includes("opt4") ? { "verification_of_short-term_subsidy_fileId_value": yup.string().required(documentUploadDetails[3]?.percetComp === -1 ? "File upload failed. Please try again." : "File is required!") } : {}),
            ...(documentupload.includes("opt5") ? { rent_allowance_request_form_fileId_value: yup.string().required(documentUploadDetails[4]?.percetComp === -1 ? "File upload failed. Please try again." : "File is required!") } : {}),
            ...(documentupload.includes("opt6") ? { housing_health_and_safety_inspection_form_fileId_value: yup.string().required(documentUploadDetails[5]?.percetComp === -1 ? "File upload failed. Please try again." : "File is required!") } : {}),
            ...(documentupload.includes("opt7") ? { "lead-based_point_disclosure_fileId_value": yup.string().required(documentUploadDetails[6]?.percetComp === -1 ? "File upload failed. Please try again." : "File is required!") } : {}),
            ...(documentupload.includes("opt8") ? { change_request_form_fileId_value: yup.string().required(documentUploadDetails[7]?.percetComp === -1 ? "File upload failed. Please try again." : "File is required!") } : {}),
            ...(documentupload.includes("opt9") ? { habitability_complaint_process_fileId_value: yup.string().required(documentUploadDetails[8]?.percetComp === -1 ? "File upload failed. Please try again." : "File is required!") } : {}),
            ...(documentupload.includes("opt10") ? { voucher_other_fileId_value: yup.string().required(documentUploadDetails[9]?.percetComp === -1 ? "File upload failed. Please try again." : "File is required!") } : {}),
            ...(documentupload.includes("opt10") ? { voucher_other_fileId_other_value: yup.string().required("Required!") } : {}),
            ...(Landlorddoc.includes("val1") ? { property_owner_agent_verification_form_fileId_value: yup.string().required(documentUploadDetails[10]?.percetComp === -1 ? "File upload failed. Please try again." : "File is required!") } : {}),
            ...(Landlorddoc.includes("val2") ? { draft_rental_assistance_payment_agreement_fileId_value: yup.string().required(documentUploadDetails[11]?.percetComp === -1 ? "File upload failed. Please try again." : "File is required!") } : {}),
            ...(Landlorddoc.includes("val3") ? { copy_of_blank_lease_fileId_value: yup.string().required(documentUploadDetails[12]?.percetComp === -1 ? "File upload failed. Please try again." : "File is required!") } : {}),
            ...(Landlorddoc.includes("val4") ? { copy_of_executed_lease_fileId_value: yup.string().required(documentUploadDetails[13]?.percetComp === -1 ? "File upload failed. Please try again." : "File is required!") } : {}),
            ...(Landlorddoc.includes("val5") ? { "move-in_walk_through_fileId_value": yup.string().required(documentUploadDetails[14]?.percetComp === -1 ? "File upload failed. Please try again." : "File is required!") } : {}),
            ...(Landlorddoc.includes("val6") ? { landlord_other_fileId_value: yup.string().required(documentUploadDetails[15]?.percetComp === -1 ? "File upload failed. Please try again." : "File is required!") } : {}),
            ...(Landlorddoc.includes("val6") ? { landlord_other_fileId_other_value: yup.string().required("Required!") } : {})
          })}
          onSubmit={this.submit}
        >
          <div className='spacer-50' />
          <div className='mt-5' />
          <h2 className="poppinsH2">
            Upload Documents
          </h2>
          <div className='mt-5' />
          <p>The following documents will be needed to reserve an AHAH-RAP voucher. They can be found on the <a href=" https://www.provider.wellpoint.com/washington-provider/patient-care/foundational-community-supports" target="_blank" >
            <u>FCS Provider Site</u></a>, under the 'AHAH' section. Please note: you do not have to upload all documents in one session.
          </p>
          <div className='spacer-16' />
          <strong>Voucher Packet</strong>
          <Label htmlFor="docCheck" />
          <div className="spacer-rem" />
          <CheckboxGroup name="docCheck" value={documentupload} onChange={this.setDocumentation}>
            <Checkbox
              label="Provider Conflict of Interest Form"
              name="Provider conflict"
              id="Provider conflict"
              className="label-font mb-23 no-display"
              groupName="docCheck"
              value="opt1"
            />
            {documentupload.includes("opt1") ?
              <AddFile fieldId={'provider_conflict_of_interest_form_fileId'} fileObj={documentUploadDetails[0]} index={0} propsData={{ documentName: 'Provider Conflict of Interest Form' }} />

              : this.resetDocumentObj(0)
            }

            <div className="mt-3" />
            <Checkbox
              label="Intent to Rent Form"
              name="Rent Form"
              id="Rent Form"
              className="label-font mb-23 no-display"
              groupName="docCheck"
              value="opt2"
            />
            {documentupload.includes("opt2") ?
              <AddFile fieldId={'intent_to_rent_form_fileId'} fileObj={documentUploadDetails[1]} index={1} propsData={{ documentName: 'Intent to Rent Form' }} />

              : this.resetDocumentObj(1)
            }
            <div className="mt-3" />
            <Checkbox
              label="Income Verification Worksheet"
              name="Verification"
              id="Verification"
              className="label-font mb-23 no-display"
              groupName="docCheck"
              value="opt3"
            />
            {documentupload.includes("opt3") ?
              <AddFile fieldId={'income_verification_worksheet_fileId'} fileObj={documentUploadDetails[2]} index={2} propsData={{ documentName: 'Income Verification Worksheet' }} />

              : this.resetDocumentObj(2)
            }
            <div className="mt-3" />
            <Checkbox
              label="Verification of Short-Term Subsidy"
              name="ShortTerm Subsidy"
              id="ShortTerm Subsidy"
              className="label-font mb-23 no-display"
              groupName="docCheck"
              value="opt4"
            />
            {documentupload.includes("opt4") ?
              <AddFile fieldId={'verification_of_short-term_subsidy_fileId'} fileObj={documentUploadDetails[3]} index={3} propsData={{ documentName: 'Verification of Short-Term Subsidy' }} />

              : this.resetDocumentObj(3)
            }
            <div className="mt-3" />
            <Checkbox
              label="Rent Allowance Request Form"
              name="Rent Allowance"
              id="Rent Allowance"
              className="label-font mb-23 no-display"
              groupName="docCheck"
              value="opt5"
            />
            {documentupload.includes("opt5") ?
              <AddFile fieldId={'rent_allowance_request_form_fileId'} fileObj={documentUploadDetails[4]} index={4} propsData={{ documentName: 'Rent Allowance Request Form' }} />

              : this.resetDocumentObj(4)
            }
            <div className="mt-3" />
            <Checkbox
              label="Housing Health and Safety Inspection (HHSI) Form"
              name="HHSI"
              id="HHSI"
              className="label-font mb-23 no-display"
              groupName="docCheck"
              value="opt6"
            />
            {documentupload.includes("opt6") ?
              <AddFile fieldId={'housing_health_and_safety_inspection_form_fileId'} fileObj={documentUploadDetails[5]} index={5} propsData={{ documentName: 'Housing Health and Safety Inspection (HHSI) Form' }} />

              : this.resetDocumentObj(5)
            }
            <div className="mt-3" />
            <Checkbox
              label="Lead-Based Paint Disclosure"
              name="Disclosure"
              id="Disclosure"
              className="label-font mb-23 no-display"
              groupName="docCheck"
              value="opt7"
            />
            {documentupload.includes("opt7") ?
              <AddFile fieldId={'lead-based_point_disclosure_fileId'} fileObj={documentUploadDetails[6]} index={6} propsData={{ documentName: 'Lead-Based Paint Disclosure' }} />

              : this.resetDocumentObj(6)
            }
            <div className="mt-3" />
            <Checkbox
              label="Change Request Form (as needed)"
              name="RequestForm"
              id="RequestForm"
              className="label-font mb-23 no-display"
              groupName="docCheck"
              value="opt8"
            />
            {documentupload.includes("opt8") ?
              <AddFile fieldId={'change_request_form_fileId'} fileObj={documentUploadDetails[7]} index={7} propsData={{ documentName: 'Change Request Form (as needed)' }} />

              : this.resetDocumentObj(7)
            }
            <div className="mt-3" />
            <Checkbox
              label="Habitability Complaint Process"
              name="Complaint Process"
              id="Complaint Process"
              className="label-font mb-23 no-display"
              groupName="docCheck"
              value="opt9"
            />
            {documentupload.includes("opt9") ?
              <AddFile fieldId={'habitability_complaint_process_fileId'} fileObj={documentUploadDetails[8]} index={8} propsData={{ documentName: 'Habitability Complaint Process' }} />

              : this.resetDocumentObj(8)
            }
            <div className="mt-3" />
            <Checkbox
              label="Other"
              name="otheropt"
              id="otheropt"
              className="label-font mb-23 no-display"
              groupName="docCheck"
              value="opt10"
            />
            {documentupload.includes("opt10") ?
              <div className="spacer-rem">
                <Row className="add-file">
                  <Col sm='6'>
                    <FormGroup for='voucher_other_fileId_other_value' className='label-font'>
                      <Label htmlFor='voucher_other_fileId_other_value'>
                        Enter Name of Document*
                      </Label>
                      <Field
                        type='text'
                        id='voucher_other_fileId_other_value'
                        name='voucher_other_fileId_other_value'
                        className='straighten-borders'
                        onChange={this.setTextDocumentName}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col sm='12'>
                    <AddFile fieldId={'voucher_other_fileId'} fileObj={documentUploadDetails[9]} index={9} propsData={{ documentName: 'Other', documentCategory: 'Voucher' }} />
                  </Col>
                </Row>
              </div>
              : this.resetDocumentObj(9)
            }
          </CheckboxGroup>
          {/* Landlord Packet */}

          <div className='spacer-16' />
          <strong>Landlord Packet</strong>
          <Label htmlFor="checkbox" />
          <div className="spacer-rem" />
          <CheckboxGroup name="checkbox" value={Landlorddoc} onChange={this.setLandlordDoc}>
            <Checkbox
              label="Property Owner/Agent Verification Form"
              name="Agent Verification"
              id="Agent Verification"
              className="label-font mb-23 no-display"
              groupName="checkbox"
              value="val1"
            />
            {Landlorddoc.includes("val1") ?
              <AddFile fieldId={'property_owner_agent_verification_form_fileId'} fileObj={documentUploadDetails[10]} index={10} propsData={{ documentName: 'Property Owner/Agent Verification Form' }} />

              : this.resetDocumentObj(10)
            }
            <div className="mt-3" />
            <Checkbox
              label="Draft Rental Assistance Payment Agreement"
              name="Rent Assistance"
              id="Rent Assistance"
              className="label-font mb-23 no-display"
              groupName="checkbox"
              value="val2"
            />
            {Landlorddoc.includes("val2") ?
              <AddFile fieldId={'draft_rental_assistance_payment_agreement_fileId'} fileObj={documentUploadDetails[11]} index={11} propsData={{ documentName: 'Draft Rental Assistance Payment Agreement' }} />

              : this.resetDocumentObj(11)
            }
            <div className="mt-3" />
            <Checkbox
              label="Copy of Blank Lease"
              name="Blank Lease"
              id="Blank Lease"
              className="label-font mb-23 no-display"
              groupName="checkbox"
              value="val3"
            />
            {Landlorddoc.includes("val3") ?
              <AddFile fieldId={'copy_of_blank_lease_fileId'} fileObj={documentUploadDetails[12]} index={12} propsData={{ documentName: 'Copy of Blank Lease' }} />

              : this.resetDocumentObj(12)
            }

            <div className="mt-3" />
            <Checkbox
              label="Copy of Executed Lease"
              name="Executed Lease"
              id="Executed Lease"
              className="label-font mb-23 no-display"
              groupName="checkbox"
              value="val4"
            />
            {Landlorddoc.includes("val4") ?
              <AddFile fieldId={'copy_of_executed_lease_fileId'} fileObj={documentUploadDetails[13]} index={13} propsData={{ documentName: 'Copy of Executed Lease' }} />

              : this.resetDocumentObj(13)
            }
            <div className="mt-3" />
            <Checkbox
              label="Move-In Walk Through"
              name="Move-in"
              id="Move-in"
              className="label-font mb-23 no-display"
              groupName="checkbox"
              value="val5"
            />
            {Landlorddoc.includes("val5") ?
              <AddFile fieldId={'move-in_walk_through_fileId'} fileObj={documentUploadDetails[14]} index={14} propsData={{ documentName: 'Move-In Walk Through' }} />

              : this.resetDocumentObj(14)
            }
            <div className="mt-3" />
            <Checkbox
              label="Other"
              name="other"
              id="other"
              className="label-font mb-23 no-display"
              groupName="checkbox"
              value="val6"
            />
            {Landlorddoc.includes("val6") ?
              <div className="spacer-rem">
                <Row className="add-file">
                  <Col sm='6'>
                    <FormGroup for='landlord_other_fileId_other_value' className='label-font'>
                      <Label htmlFor='landlord_other_fileId_other_value'>
                        Enter Name of Document*
                      </Label>
                      <Field
                        type='text'
                        id='landlord_other_fileId_other_value'
                        name='landlord_other_fileId_other_value'
                        className='straighten-borders'
                        onChange={this.setDocumentName}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col sm='12'>
                    <AddFile fieldId={'landlord_other_fileId'} fileObj={documentUploadDetails[15]} index={15} propsData={{ documentName: 'Other', documentCategory: 'Landlord' }} />
                  </Col>
                </Row>
              </div>
              : this.resetDocumentObj(15)
            }
          </CheckboxGroup>



          <div className="spacer-64" />

          <Button type="button" color={"primary"} className={'btn btn-primary straighten-borders buttonBack'} onClick={this.goBack}>
            Back
          </Button>
          <Button type="submit" color={"primary"} className={'btn btn-primary awardeeNextBtn mb-50'}>
            Next
          </Button>
        </Form>
      </div>

    )
  }
}
DocumentationVoucher.propTypes = {
  history: PropTypes.object,
}
